import { Group, MantineSize } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { ReactElement } from 'react';

export interface DateRangeFilterProps {
  value: [Date | null, Date | null];
  onChange: (value: [Date | null, Date | null]) => void;
  fromLabel?: string;
  toLabel?: string;
  size?: MantineSize;
}

export function DateRangeFilter({
  value,
  onChange,
  fromLabel = 'From',
  toLabel = 'To',
  size,
}: DateRangeFilterProps): ReactElement {
  return (
    <Group gap="xs" wrap="nowrap">
      <DatePickerInput
        label={fromLabel}
        value={value[0]}
        onChange={(d) => onChange([d as Date | null, value[1]])}
        clearable
        size={size}
      />
      <DatePickerInput
        label={toLabel}
        value={value[1]}
        onChange={(d) => onChange([value[0], d as Date | null])}
        clearable
        size={size}
      />
    </Group>
  );
}
